import {useEffect, useState} from "react";
import {reportingError, reportingPreset} from "./analytics-filters";

const sameQuery = (draft, applied) => ["from", "to", "rankBy"].every(key => draft[key] === applied[key]) &&
    Number(draft.limit) === Number(applied.limit);

export default function useAnalyticsFilters() {
    const [draft, setDraft] = useState(() => ({...reportingPreset("7"), preset: "7", limit: "10", rankBy: "UNITS"}));
    const [applied, setApplied] = useState(draft);
    const error = reportingError(draft);
    const pending = !error && !sameQuery(draft, applied);

    useEffect(() => {
        if (!pending) return;
        // Let typing settle before querying; clearing/invalidating a field cancels its pending query.
        const timer = setTimeout(() => setApplied(draft), 350);
        return () => clearTimeout(timer);
    }, [draft, pending]);

    const applyLatest = () => {
        if (!pending) return false;
        setApplied(draft);
        return true;
    };
    return {draft, setDraft, applied, error, pending, applyLatest};
}
